// src/components/ProductDetail/ProductGallery.tsx

import { useRef, useState } from "react"
import Slider from "react-slick"
import { Tooltip } from "antd"
import "antd/dist/reset.css"
import ProductImageModal from "./ProductImageModal"
import HotDealInfo from "./HotDealInfo"
// ⚠️ BẮT BUỘC PHẢI IMPORT
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import QtyControl from "./QtyControl"
import CouponSection from "./CouponSection"

export default function ProductGallery() {
    const sliderRef = useRef<Slider | null>(null)
    const [modalOpen, setModalOpen] = useState(false)

    const images = [
        "https://gcs.buymed.com/thuocsi-live/images/2024ff9ec7d1f7f85ab67e0e4ea5c4ee",
        "https://gcs.buymed.com/thuocsi-live/images/2024345df3cdee930278ff8501e5542d",
        "https://gcs.buymed.com/thuocsi-live/images/2023fa03d5e9fa8e77f3f0cfb71c54cc",
        "https://gcs.buymed.com/thuocsi-live/images/20230d59d4c0129c745de731aca768a3",
    ]

    // Ảnh lớn đang active
    const [activeImage, setActiveImage] = useState(images[0])
    const activeIndex = images.indexOf(activeImage)

    // Slider thumbnail (NGANG – đúng hình mẫu)
    const sliderSettings = {
        slidesToShow: Math.min(3, images.length),
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        swipeToSlide: true,
    }

    const [open, setOpen] = useState(false)
    const [pos, setPos] = useState({ top: 0, left: 0 })
    const priceRef = useRef<HTMLDivElement>(null)

    const handleEnter = () => {
        if (!priceRef.current) return
        const rect = priceRef.current.getBoundingClientRect()

        setPos({
            top: rect.top - 10,
            left: rect.left + rect.width / 2,
        })

        setOpen(true)
    }

    const handleLeave = () => {
        setOpen(false)
    }

    return (
        <div className="MuiGrid-root styles_wrapper__Xa5hm MuiGrid-container MuiGrid-spacing-xs-3">

            {/* ================= LEFT ================= */}
            <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-4">
                <div className="styles_bigImage__9eFTb">

                    {/* ===== MAIN IMAGE ===== */}
                    <div className="MuiGrid-root styles_imageShow__0_WTL MuiGrid-item MuiGrid-grid-xs-12">
                        <div className="styles_wrapperImage__Sngdw">
                            <div className="styles_container__boKoW">
                                <div className="styles_image__g98t2 w-full h-full">
                                    {/* <div className="styles_tooltipLeft__UbYbr"><div className="styles_customButton__VYlIZ"><svg className="MuiSvgIcon-root styles_icon__wvMZT" focusable="false" viewBox="0 0 24 24" aria-hidden="true" style={{ fontSize: '24px', color: 'rgba(0, 0, 0, 0.2)' }}><path d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"></path></svg></div></div> */}

                                    <div className="styles_tooltipRight__JopJL"><div className="styles_customButton__VYlIZ"><svg className="MuiSvgIcon-root styles_icon__wvMZT" focusable="false" viewBox="0 0 24 24" aria-hidden="true" style={{ fontSize: '24px', color: 'rgba(0, 0, 0, 0.2)' }}><path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"></path></svg></div></div>
                                    <button className="MuiButtonBase-root openImg w-full h-full" type="button" onClick={() => setModalOpen(true)}>
                                        <span style={{ boxSizing: 'border-box', display: 'inline-block', overflow: 'hidden', width: '100%', height: '100%', background: 'none', opacity: 1, border: '0px', margin: '0px', padding: '0px', position: 'relative', maxWidth: '100%' }}>
                                            <img
                                                src={activeImage}
                                                alt="Cồn 90 độ direh perfect havico (c/1000ml)"
                                                style={{
                                                    position: 'absolute',
                                                    inset: '0px',
                                                    boxSizing: 'border-box',
                                                    padding: '0px',
                                                    border: 'none',
                                                    margin: 'auto',
                                                    display: 'block',
                                                    width: '0px',
                                                    height: '0px',
                                                    minWidth: '100%',
                                                    maxWidth: '100%',
                                                    minHeight: '100%',
                                                    maxHeight: '100%',
                                                    objectFit: 'contain'
                                                }}
                                            />
                                        </span>
                                    </button>

                                </div>
                            </div>
                            {/* ===== THUMBNAIL SLIDER ===== */}
                            <div className="styles_sliderContainer__FwX5B styles_imageSlider__FV2Sv">
                                <div className="styles_wrapperSlider__ChLsw">

                                    {/* ◀ PREV */}
                                    <div
                                        className="styles_wrapperLeft__9oUEY"
                                        role="button"
                                        aria-label="prev image"
                                        onClick={() => sliderRef.current?.slickPrev()}
                                    >
                                        <i className="styles_arrow__BgiX1 styles_left__nHNaN" />
                                    </div>

                                    {/* SLIDER */}
                                    <Slider ref={sliderRef} {...sliderSettings}>
                                        {images.map((img, index) => (
                                            <div key={index}>
                                                <button
                                                    className="MuiButtonBase-root openImg"
                                                    type="button"
                                                    onMouseEnter={() => setActiveImage(img)} // ✅ HOVER ĐỔI ẢNH
                                                >
                                                    <div
                                                        className={`styles_imageItem__bGCgm ${activeImage === img ? "styles_active__wKQN9" : ""
                                                            }`}
                                                    >
                                                        <img src={img} alt="" />
                                                    </div>
                                                </button>
                                            </div>
                                        ))}
                                    </Slider>

                                    {/* ▶ NEXT */}
                                    <div
                                        className="styles_wrapperRight__ryBSR"
                                        role="button"
                                        aria-label="next image"
                                        onClick={() => sliderRef.current?.slickNext()}
                                    >
                                        <i className="styles_arrow__BgiX1 styles_right__snSLq" />
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="styles_buyInfo__7dnyO">
                            <div className="styles_countBuy__Ev3_S">
                                <span
                                    style={{
                                        boxSizing: "border-box",
                                        display: "inline-block",
                                        overflow: "hidden",
                                        width: "initial",
                                        height: "initial",
                                        background: "none",
                                        opacity: 1,
                                        border: 0,
                                        margin: 0,
                                        padding: 0,
                                        position: "relative",
                                        maxWidth: "100%",
                                    }}
                                >
                                    <span
                                        style={{
                                            boxSizing: "border-box",
                                            display: "block",
                                            width: "initial",
                                            height: "initial",
                                            background: "none",
                                            opacity: 1,
                                            border: 0,
                                            margin: 0,
                                            padding: 0,
                                            maxWidth: "100%",
                                        }}
                                    >
                                        <img
                                            alt=""
                                            aria-hidden="true"
                                            src="data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20version='1.1'%20width='16'%20height='16'/%3e"
                                            style={{
                                                display: "block",
                                                maxWidth: "100%",
                                                width: "initial",
                                                height: "initial",
                                                background: "none",
                                                opacity: 1,
                                                border: 0,
                                                margin: 0,
                                                padding: 0,
                                            }}
                                        />
                                    </span>

                                    <img
                                        alt="cart_icon"
                                        data-origin-url="https://cdn-web-next.thuocsi.vn/images/icon/shopping-cart.svg"
                                        src="https://cdn-web-next.thuocsi.vn/images/icon/shopping-cart.svg"
                                        decoding="async"
                                        style={{
                                            position: "absolute",
                                            inset: 0,
                                            boxSizing: "border-box",
                                            padding: 0,
                                            border: "none",
                                            margin: "auto",
                                            display: "block",
                                            width: 0,
                                            height: 0,
                                            minWidth: "100%",
                                            maxWidth: "100%",
                                            minHeight: "100%",
                                            maxHeight: "100%",
                                        }}
                                    />
                                </span>

                                <p className="MuiTypography-root styles_numberBuy__3nhbg MuiTypography-body1">
                                    215
                                </p>

                                <p className="MuiTypography-root styles_typography__yL4Xa MuiTypography-body1">
                                    {" "}
                                    Lượt mua trong 24 giờ
                                </p>
                            </div>

                            <p className="MuiTypography-root styles_score__sUEVW MuiTypography-body1" />
                        </div>
                        <QtyControl
                            max={20}
                            value={1}
                            onChange={(qty) => {
                                console.log("Số lượng:", qty)
                            }}
                        />

                        <div className="styles_typography__yL4Xa">
                            <p className="MuiTypography-root styles_text_limit__z1qJ0 MuiTypography-body1">Đặt tối đa 311 sản phẩm</p>
                        </div>
                    </div>

                </div>
            </div>

            {/* ================= RIGHT ================= */}
            <div className="MuiGrid-root styles_rightGrid__PGQ7R MuiGrid-item MuiGrid-grid-xs-8">
                <HotDealInfo
                    sold={5764}
                    progressPercent={55}
                    endTime={new Date(Date.now() + 7 * 24 * 60 * 60 * 1000)}
                />
                <div>
                    <h1 className="MuiTypography-root styles_typographyTitle__RTV69 MuiTypography-h1">
                        <span>
                            <span style={{ color: "rgb(185, 143, 15)" }}>
                                Hàng hãng
                            </span>
                            <span> - </span>
                        </span>
                        Nhỏ Mắt Sanlein 0.1% Santen (C/5ml)
                    </h1>

                    <p className="MuiTypography-root styles_typographyRight__0cmji MuiTypography-body1">
                        Hộp 1 chai x 5ml
                    </p>
                </div>

                <div className="styles_rowPrice__giLxB">
                    <div
                        className="styles_priceInfo__66bgZ"
                        ins-init-condition="#W2NsYXNzKj1fcHJpY2VJbmZvX19dLCBbY2xhc3MqPXN0eWxlc19yZWZlcmVuY2VSZXRhaWxQcmljZV9fXQ=="
                    >
                        <div className="relative">
                            <div
                                ref={priceRef}
                                onMouseEnter={handleEnter}
                                onMouseLeave={handleLeave}
                                className="cursor-pointer"
                            >
                                <p className="MuiTypography-root styles_price__uDwZz flex items-end MuiTypography-body1 gap-[8px]">

                                    {/* PRICE CANVAS */}
                                    <div className="styles_flex_no_wrap__1vvft MuiBox-root css-0">
                                        <div
                                            className="styles_canvasPrice__vw932"
                                            style={{ height: "30px" }}
                                        >
                                            65.000 ₫
                                        </div>
                                    </div>

                                    {/* VOUCHER ICON */}
                                    <span
                                        style={{
                                            boxSizing: "border-box",
                                            display: "inline-block",
                                            overflow: "hidden",
                                            width: "initial",
                                            height: "initial",
                                            background: "none",
                                            opacity: 1,
                                            border: 0,
                                            margin: 0,
                                            padding: 0,
                                            position: "relative",
                                            maxWidth: "100%",
                                        }}
                                    >
                                        <span
                                            style={{
                                                boxSizing: "border-box",
                                                display: "block",
                                                width: "initial",
                                                height: "initial",
                                                background: "none",
                                                opacity: 1,
                                                border: 0,
                                                margin: 0,
                                                padding: 0,
                                                maxWidth: "100%",
                                            }}
                                        >
                                            <img
                                                alt=""
                                                aria-hidden="true"
                                                src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2720%27%20height=%2720%27/%3e"
                                                style={{
                                                    display: "block",
                                                    maxWidth: "100%",
                                                    width: "initial",
                                                    height: "initial",
                                                    background: "none",
                                                    opacity: 1,
                                                    border: 0,
                                                    margin: 0,
                                                    padding: 0,
                                                }}
                                            />
                                        </span>

                                        <img
                                            alt="icon"
                                            src="https://cdn-web-next.thuocsi.vn/icons/productDetail/voucher_icon.svg"
                                            decoding="async"
                                            data-nimg="intrinsic"
                                            style={{
                                                position: "absolute",
                                                inset: 0,
                                                boxSizing: "border-box",
                                                padding: 0,
                                                border: "none",
                                                margin: "auto",
                                                display: "block",
                                                width: 0,
                                                height: 0,
                                                minWidth: "100%",
                                                maxWidth: "100%",
                                                minHeight: "100%",
                                                maxHeight: "100%",
                                            }}
                                        />
                                    </span>

                                </p>
                            </div>

                            {open && (
                                <div
                                    role="tooltip"
                                    className="MuiTooltip-popper jss266"
                                    style={{
                                        position: "fixed",
                                        top: "auto",
                                        bottom: "100%",
                                        left: 0,
                                        transform: `translate3d(${pos.left}px, ${pos.top}px, 0) translateX(-50%)`,
                                        willChange: "transform",
                                        zIndex: 1300,
                                    }}
                                >
                                    <div
                                        className="MuiTooltip-tooltip jss265 MuiTooltip-tooltipPlacementTop"
                                        style={{
                                            opacity: 1,
                                            transform: "none",
                                            transition:
                                                "opacity 200ms cubic-bezier(0.4, 0, 0.2, 1), transform 133ms cubic-bezier(0.4, 0, 0.2, 1)",
                                        }}
                                    >
                                        {/* ================= TOOLTIP CONTENT ================= */}
                                        <div className="text-black flex flex-col gap-[12px] z-50">

                                            <div className="text-[16px] font-ggsm">
                                                Chi tiết giá
                                            </div>

                                            {/* GIÁ GỐC */}
                                            <div className="grid grid-cols-3">
                                                <div className="col-span-2">
                                                    <div className="text-[14px] leading-5">
                                                        Giá gốc
                                                    </div>
                                                </div>
                                                <div className="col-span-1 text-right text-[14px] font-ggsm">
                                                    68.400đ
                                                </div>
                                            </div>

                                            <hr className="MuiDivider-root" />

                                            {/* GIẢM GIÁ SỐC */}
                                            <div className="grid grid-cols-3">
                                                <div className="col-span-2">
                                                    <div className="text-[14px] leading-5 font-ggsm">
                                                        Giảm giá sốc
                                                    </div>
                                                </div>
                                                <div className="col-span-1 text-right text-[#F5222D] text-[14px]">
                                                    -2.900đ
                                                </div>
                                            </div>

                                            {/* THANH TOÁN */}
                                            <div className="grid grid-cols-3">
                                                <div className="col-span-2 flex flex-col gap-[4px]">
                                                    <div className="text-[14px] leading-5 font-ggsm">
                                                        Ưu đãi phương thức thanh toán
                                                    </div>
                                                    <div className="text-[12px] text-[#8C8C8C]">
                                                        Giảm giá 0.5% khi thanh toán chuyển khoản
                                                    </div>
                                                </div>
                                                <div className="col-span-1 text-right text-[#F5222D] text-[14px]">
                                                    -300đ
                                                </div>
                                            </div>

                                            {/* MÃ GIẢM GIÁ */}
                                            <div className="grid grid-cols-3">
                                                <div className="col-span-2 flex flex-col gap-[4px]">
                                                    <div className="text-[14px] leading-5 font-ggsm">
                                                        Mã giảm giá sàn thuocsi
                                                    </div>
                                                    <div className="text-[12px] text-[#8C8C8C]">
                                                        GIẢM 0.1% Cho đơn hàng từ 10.000.000đ
                                                    </div>

                                                    <button
                                                        className="MuiButtonBase-root MuiButton-root MuiButton-text max-w-max p-0"
                                                        type="button"
                                                    >
                                                        <span className="MuiButton-label">
                                                            <div className="text-sm flex items-center text-[#1D39C4]">
                                                                Xem chi tiết&nbsp;&nbsp;
                                                                <svg
                                                                    className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium text-[#1D39C4] !w-[12px] !h-[12px]"
                                                                    viewBox="0 0 24 24"
                                                                >
                                                                    <path d="M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2z" />
                                                                </svg>
                                                            </div>
                                                        </span>
                                                    </button>
                                                </div>

                                                <div className="col-span-1 text-right text-[#F5222D] text-[14px]">
                                                    -100đ
                                                </div>
                                            </div>

                                            <hr className="MuiDivider-root" />

                                            {/* GIÁ CUỐI */}
                                            <div className="grid grid-cols-3">
                                                <div className="col-span-2 text-[14px] leading-5">
                                                    Giá tạm tính <br />
                                                    (khi áp dụng các mã giảm giá trên)
                                                </div>
                                                <div className="col-span-1 text-right text-[14px] font-ggsm !text-[#15A959]">
                                                    65.100đ
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* ORIGINAL PRICE + DISCOUNT */}
                        <div style={{ display: "flex", gap: "10px" }}>
                            <span className="styles_originalPrice__5lefU">
                                <div className="styles_flex_no_wrap__1vvft MuiBox-root css-0">
                                    <div
                                        className="styles_canvasPrice__vw932"
                                        style={{ height: "21px" }}
                                    >
                                        68.000 ₫
                                    </div>
                                </div>
                            </span>

                            <span className="styles_discountPercent__SrLu1">-4%</span>
                        </div>
                    </div>

                    {/* ASSESS PRICE */}
                    <div className="styles_assessPrice__0YRCt">
                        <p className="MuiTypography-root styles_typographyRight__0cmji MuiTypography-body1">
                            Bạn thấy giá này?
                        </p>

                        {/* LIKE */}
                        <div className="styles_container__EWHMz">
                            <span>
                                <button
                                    className="MuiButtonBase-root MuiIconButton-root styles_root__h_lXN"
                                    type="button"
                                >
                                    <span className="MuiIconButton-label">
                                        <svg
                                            className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-vubbuv"
                                            focusable="false"
                                            aria-hidden="true"
                                            viewBox="0 0 24 24"
                                        >
                                            <path d="m13.11 5.72-.57 2.89c-.12.59.04 1.2.42 1.66.38.46.94.73 1.54.73H20v1.08L17.43 18H9.34c-.18 0-.34-.16-.34-.34V9.82l4.11-4.1M14 2 7.59 8.41C7.21 8.79 7 9.3 7 9.83v7.83C7 18.95 8.05 20 9.34 20h8.1c.71 0 1.36-.37 1.72-.97l2.67-6.15c.11-.25.17-.52.17-.8V11c0-1.1-.9-2-2-2h-5.5l.92-4.65c.05-.22.02-.46-.08-.66-.23-.45-.52-.86-.88-1.22L14 2zM4 9H2v11h2c.55 0 1-.45 1-1v-9c0-.55-.45-1-1-1z" />
                                        </svg>
                                    </span>
                                    <span className="MuiTouchRipple-root" />
                                </button>
                            </span>

                            <p className="MuiTypography-root styles_typography__KesV2 MuiTypography-body1">
                                Hợp lí
                            </p>
                        </div>

                        {/* DISLIKE */}
                        <div className="styles_container__EWHMz">
                            <span>
                                <button
                                    className="MuiButtonBase-root MuiIconButton-root styles_root__h_lXN"
                                    type="button"
                                >
                                    <span className="MuiIconButton-label">
                                        <svg
                                            className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-vubbuv"
                                            focusable="false"
                                            aria-hidden="true"
                                            viewBox="0 0 24 24"
                                        >
                                            <path d="m10.89 18.28.57-2.89c.12-.59-.04-1.2-.42-1.66-.38-.46-.94-.73-1.54-.73H4v-1.08L6.57 6h8.09c.18 0 .34.16.34.34v7.84l-4.11 4.1M10 22l6.41-6.41c.38-.38.59-.89.59-1.42V6.34C17 5.05 15.95 4 14.66 4h-8.1c-.71 0-1.36.37-1.72.97l-2.67 6.15c-.11.25-.17.52-.17.8V13c0 1.1.9 2 2 2h5.5l-.92 4.65c-.05.22-.02.46.08.66.23.45.52.86.88 1.22L10 22zm10-7h2V4h-2c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1z" />
                                        </svg>
                                    </span>
                                    <span className="MuiTouchRipple-root" />
                                </button>
                            </span>

                            <p className="MuiTypography-root styles_typography__KesV2 MuiTypography-body1">
                                Cao
                            </p>
                        </div>
                    </div>
                </div>

                <div className="flex w-fit gap-6 items-center rounded-[30px] bg-[#FDF0DD] h-[25px]">
                    {/* LEFT BADGE */}
                    <div className="flex gap-2 items-center justify-center px-3 bg-[linear-gradient(90deg,_#FF3D28_0%,_#FF9549_100%)] rounded-[30px] h-full">
                        <svg
                            width="16"
                            height="15"
                            viewBox="0 0 16 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M9.5 6C9.63261 6 9.75979 5.94732 9.85355 5.85355C9.94732 5.75979 10 5.63261 10 5.5C10 5.36739 9.94732 5.24021 9.85355 5.14645C9.75979 5.05268 9.63261 5 9.5 5H8.5V4.5C8.5 4.36739 8.44732 4.24021 8.35355 4.14645C8.25979 4.05268 8.13261 4 8 4C7.86739 4 7.74021 4.05268 7.64645 4.14645C7.55268 4.24021 7.5 4.36739 7.5 4.5V5H7C6.73478 5 6.48043 5.10536 6.29289 5.29289C6.10536 5.48043 6 5.73478 6 6V7C6 7.26522 6.10536 7.51957 6.29289 7.70711C6.48043 7.89464 6.73478 8 7 8H9V9H6.5C6.36739 9 6.24021 9.05268 6.14645 9.14645C6.05268 9.24021 6 9.36739 6 9.5C6 9.63261 6.05268 9.75979 6.14645 9.85355C6.24021 9.94732 6.36739 10 6.5 10H7.5V10.5C7.5 10.6326 7.55268 10.7598 7.64645 10.8536C7.74021 10.9473 7.86739 11 8 11C8.13261 11 8.25979 10.9473 8.35355 10.8536C8.44732 10.7598 8.5 10.6326 8.5 10.5V10H9C9.26522 10 9.51957 9.89464 9.70711 9.70711C9.89464 9.51957 10 9.26522 10 9V8C10 7.73478 9.89464 7.48043 9.70711 7.29289C9.51957 7.10536 9.26522 7 9 7H7V6H9.5Z"
                                fill="white"
                                stroke="white"
                                strokeWidth="0.4"
                            />
                            <path
                                d="M12.8551 9.64497C12.8086 9.59811 12.7533 9.56091 12.6924 9.53552C12.6314 9.51014 12.5661 9.49707 12.5001 9.49707C12.4341 9.49707 12.3687 9.51014 12.3078 9.53552C12.2469 9.56091 12.1916 9.59811 12.1451 9.64497L10.1451 11.645C10.0757 11.7153 10.0287 11.8046 10.01 11.9016C9.99132 11.9986 10.0018 12.0989 10.0401 12.19C10.0776 12.2813 10.1413 12.3594 10.2231 12.4146C10.305 12.4698 10.4014 12.4995 10.5001 12.5H11.0001V14C11.0001 14.1326 11.0527 14.2598 11.1465 14.3535C11.2403 14.4473 11.3675 14.5 11.5001 14.5C11.6327 14.5 11.7599 14.4473 11.8536 14.3535C11.9474 14.2598 12.0001 14.1326 12.0001 14V12C12.0004 11.8978 11.9694 11.798 11.9113 11.714C11.8532 11.6299 11.7708 11.5657 11.6751 11.53L12.5001 10.705L13.3251 11.53C13.2294 11.5657 13.1469 11.6299 13.0888 11.714C13.0307 11.798 12.9997 11.8978 13.0001 12V14C13.0001 14.1326 13.0527 14.2598 13.1465 14.3535C13.2403 14.4473 13.3675 14.5 13.5001 14.5C13.6327 14.5 13.7599 14.4473 13.8536 14.3535C13.9474 14.2598 14.0001 14.1326 14.0001 14V12.5H14.5001C14.5988 12.4995 14.6951 12.4698 14.777 12.4146C14.8589 12.3594 14.9226 12.2813 14.9601 12.19C14.9984 12.0989 15.0088 11.9986 14.9901 11.9016C14.9714 11.8046 14.9244 11.7153 14.8551 11.645L12.8551 9.64497Z"
                                fill="white"
                                stroke="white"
                                strokeWidth="0.4"
                            />
                            <path
                                d="M9.385 13.34C8.93097 13.4461 8.46627 13.4998 8 13.5C6.81332 13.5 5.65328 13.1481 4.66658 12.4888C3.67989 11.8295 2.91085 10.8925 2.45673 9.7961C2.0026 8.69975 1.88378 7.49335 2.11529 6.32946C2.3468 5.16558 2.91825 4.09648 3.75736 3.25736C4.59648 2.41825 5.66558 1.8468 6.82946 1.61529C7.99335 1.38378 9.19975 1.5026 10.2961 1.95673C11.3925 2.41085 12.3295 3.17989 12.9888 4.16658C13.6481 5.15328 14 6.31332 14 7.5C14.001 8.04622 13.9253 8.58987 13.775 9.115C13.7529 9.17918 13.7441 9.24719 13.7491 9.31488C13.7542 9.38257 13.7729 9.44853 13.8043 9.50874C13.8356 9.56895 13.8789 9.62214 13.9315 9.66508C13.984 9.70801 14.0448 9.7398 14.1101 9.75849C14.1753 9.77718 14.2437 9.78239 14.311 9.7738C14.3784 9.76521 14.4432 9.743 14.5017 9.70853C14.5602 9.67405 14.611 9.62803 14.6511 9.57327C14.6912 9.51851 14.7198 9.45615 14.735 9.39C14.9108 8.77539 15 8.13926 15 7.5C15 6.11553 14.5895 4.76216 13.8203 3.61101C13.0511 2.45987 11.9579 1.56266 10.6788 1.03285C9.3997 0.503033 7.99224 0.36441 6.63437 0.634506C5.2765 0.904603 4.02922 1.57129 3.05026 2.55026C2.07129 3.52922 1.4046 4.7765 1.13451 6.13437C0.86441 7.49224 1.00303 8.8997 1.53285 10.1788C2.06266 11.4579 2.95987 12.5511 4.11101 13.3203C5.26216 14.0895 6.61553 14.5 8 14.5C8.54393 14.5003 9.08599 14.4365 9.615 14.31C9.73474 14.2714 9.83553 14.1891 9.89729 14.0796C9.95905 13.97 9.97723 13.8411 9.94821 13.7187C9.91918 13.5963 9.84509 13.4894 9.7407 13.4192C9.63632 13.349 9.50931 13.3207 9.385 13.34Z"
                                fill="white"
                                stroke="white"
                                strokeWidth="0.4"
                            />
                        </svg>

                        <span className="text-white text-[14px]">
                            Lợi nhuận bán lẻ
                        </span>
                    </div>

                    {/* RIGHT CONTENT */}
                    <div className="flex items-center">
                        <div className="styles_flex_no_wrap__1vvft MuiBox-root css-0">
                            <div
                                className="styles_canvasPrice__vw932"
                                style={{ height: '21px' }}
                            >
                                44.750 ₫
                            </div>
                        </div>

                        <Tooltip
                            placement="top"
                            mouseEnterDelay={0}
                            mouseLeaveDelay={0}
                            overlayClassName="profit-tooltip"
                            overlayInnerStyle={{ padding: 0 }}
                            title={
                                <div className="!bg-white min-w-[384px] shadow-[0px_0px_30px_0px_#0000001F] rounded-[10px]">
                                    <div className="flex flex-col gap-2 p-4">
                                        <p className="text-[14px] font-[ggsm] text-[#1F1F1F]">
                                            Đây là những sản phẩm thuộc nhóm có lợi nhuận cao mà thuocsi gợi ý cho bạn
                                        </p>

                                        <div className="flex justify-between items-center">
                                            <span className="text-[14px] text-[#1F1F1F] font-[ggsr]">
                                                Giá bán lẻ gợi ý
                                            </span>

                                            <span className="text-[14px] text-[#005c29] font-[ggsr]">
                                                69.000 ₫
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            }
                        >
                            {/* BUTTON */}
                            <button
                                type="button"
                                className="MuiButtonBase-root MuiIconButton-root MuiIconButton-sizeMedium css-1yxmbwk"
                            >
                                <svg
                                    className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium text-[#1D39C4] !h-4 !w-4"
                                    viewBox="0 0 24 24"
                                >
                                    <path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
                                </svg>
                            </button>
                        </Tooltip>
                    </div>
                </div>

                <div className="styles_hightLightTag__Wk7k7">
                    {/* TAG 1 */}
                    <a href="/products/loading?tag=3ABC">
                        <div
                            className="MuiGrid-root tag_tag_containerv2__66m1A tag_normal_tag_container__Twl9u"
                            style={{
                                borderColor: "rgb(242, 244, 250)",
                                color: "var(--primary-color)",
                                backgroundColor: "rgb(242, 244, 250)",
                            }}
                        >
                            <span
                                style={{
                                    boxSizing: "border-box",
                                    display: "inline-block",
                                    overflow: "hidden",
                                    width: "initial",
                                    height: "initial",
                                    background: "none",
                                    opacity: 1,
                                    border: 0,
                                    margin: 0,
                                    padding: 0,
                                    position: "relative",
                                    maxWidth: "100%",
                                }}
                            >
                                <span
                                    style={{
                                        boxSizing: "border-box",
                                        display: "block",
                                        width: "initial",
                                        height: "initial",
                                        background: "none",
                                        opacity: 1,
                                        border: 0,
                                        margin: 0,
                                        padding: 0,
                                        maxWidth: "100%",
                                    }}
                                >
                                    <img
                                        alt=""
                                        aria-hidden="true"
                                        src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2715%27%20height=%2715%27/%3e"
                                        style={{
                                            display: "block",
                                            maxWidth: "100%",
                                            width: "initial",
                                            height: "initial",
                                            background: "none",
                                            opacity: 1,
                                            border: 0,
                                            margin: 0,
                                            padding: 0,
                                        }}
                                    />
                                </span>

                                <img
                                    data-origin-url="https://thuocsi.vn/icons/tag/ban_chay.svg"
                                    src="https://thuocsi.vn/icons/tag/ban_chay.svg"
                                    decoding="async"
                                    data-nimg="intrinsic"
                                    className="style_icon_svg__xHhyG"
                                    style={{
                                        position: "absolute",
                                        inset: 0,
                                        boxSizing: "border-box",
                                        padding: 0,
                                        border: "none",
                                        margin: "auto",
                                        display: "block",
                                        width: 0,
                                        height: 0,
                                        minWidth: "100%",
                                        maxWidth: "100%",
                                        minHeight: "100%",
                                        maxHeight: "100%",
                                    }}
                                />
                                <noscript />
                            </span>

                            <p
                                className="MuiTypography-root tag_nameTag__RvjhU MuiTypography-body1"
                                style={{ fontFamily: "ggsr" }}
                            >
                                Bán Chạy
                            </p>
                        </div>
                    </a>

                    {/* TAG 2 */}
                    <a href="/deals">
                        <div
                            className="MuiGrid-root tag_tag_container__Ypz6S tag_normal_tag_container__Twl9u"
                            style={{
                                borderColor: "rgb(220, 53, 69)",
                                color: "rgb(255, 255, 255)",
                                backgroundColor: "rgb(220, 53, 69)",
                            }}
                        >
                            <p className="MuiTypography-root tag_nameTag__RvjhU MuiTypography-body1">
                                Khuyến Mãi
                            </p>
                        </div>
                    </a>
                </div>

                <CouponSection />
            </div>

            <ProductImageModal
                open={modalOpen}
                images={images}
                activeIndex={activeIndex}
                onClose={() => setModalOpen(false)}
                onChange={(i) => setActiveImage(images[i])}
            />

        </div>
    )
}
